import React from 'react';

import logoUrl from './xquant-logo.png';

interface LogoProps {
  size?: number;
  className?: string;
  alt?: string;
}

export const XquantLogo: React.FC<LogoProps> = ({ size = 32, className, alt = 'xquant' }) => (
  <img
    src={logoUrl}
    alt={alt}
    className={['xquant-logo-img', className].filter(Boolean).join(' ')}
    style={{
      display: 'inline-block',
      width: size,
      height: size,
      objectFit: 'contain',
    }}
  />
);

export default XquantLogo;
